<template>
    <el-dialog
    :visible.sync="data.dialogVisible"
    width="85%"
    top="2vh"
    custom-class="modalEditShop">
    <template slot="title">
        <h1 style="margin:unset;text-align:left;">แก้ไขข้อมูลร้านค้า</h1>
    </template>
    <el-tabs tab-position="left" v-model="activeName">
        <el-tab-pane v-for="item in MenuList" :key="item.id" :label="item.name" :name="String(item.id)" :disabled="checkDisable(item.id)"></el-tab-pane>
        <!-- <keep-alive> -->
            <component
            :is="currentTabComponent"
            :data.sync="data"
            :geoHierarchyData="geoHierarchyData"
            :provinceArray="provinceArray"
            :zipcodeArray="zipcodeArray"
            :isSubmitForm="isSubmitForm"
            :isCancel="isCancel"
            @onCancel="(value)=>isCancel = value"
            ref="shopDialogInfo"></component>
        <!-- </keep-alive> -->
    </el-tabs>
    <span slot="footer" class="dialog-footer">

        <el-button @click="onCancel" type="danger" plain>ยกเลิก</el-button>
        <el-button type="primary" @click="submitForm()" v-if="checkBtnShow">บันทึก</el-button>
    </span>
    </el-dialog>
</template>
<script>
import fgApi from '@/services/fillgoods'
import ShopInfo from '@/components/Shop/DialogShop/ShopInfo'
import ShopBankInfo from '@/components/Shop/DialogShop/ShopBankInfo'
import CourierLimit from '@/components/Shop/DialogShop/CourierLimit'
import WeightRate from '@/components/Shop/DialogShop/WeightRate'
import ShopService from '@/components/Shop/DialogShop/ShopService'
import FinanceConfig from '@/components/Shop/DialogShop/FinanceConfig'
import LogHistory from '@/components/Shop/DialogShop/LogHistory'
const initForm = {
    shopId: null,
    name: null,
    shopCode: null,
    goodsType: null,
    phoneNumber: null,
    line: null,
    facebook: null,
    instagram: null,
    address: null,
    subDistrict: null,
    district: null,
    province: null,
    zipcode: null,
    activeUploadSlip: null,
    bankAccountType: null,
    bankAccountName: null,
    taxId: null,
    bankAccountEmail: null,
    bankAccountNumber: null,
    bankName: null,
    bankAccountAddress: null,
    bankAccountSubDistrict: null,
    bankAccountDistrict: null,
    bankAccountProvince: null,
    bankAccountZipcode: null,
    dimWeightMultiplier: null,
    weightRate: null,
    dimensionRate: null,
    financeConfig: null,
    courierLimitDay: null,
    legalName: null,
    pickedUpDistrict: null,
    pickedUpProvince: null,
    pickedUpSubDistrict: null,
    pickedUpZipcode: null,
    pickedUpAddress: null,
    pickedUpAddressId: null,
    pickupAddressId: null,
    facebookPageId: null,
    autoSendMessage: false
}
export default {
    name: 'dialogShopDetail',
    components: {
        ShopInfo,
        ShopBankInfo,
        CourierLimit,
        WeightRate,
        ShopService,
        FinanceConfig,
        LogHistory
    },
    props: {
        data: {
            type: Object
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        zipcodeArray: {
            type: Array,
            default: null
        }
    },
    watch: {
        'data.dialogVisible' (val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.shopDialogInfo.$refs['shopInfo'].clearValidate()
                })
                for (const key in this.paramForm) {
                    this.lsh[key] = this.data.shopDetail[key]
                }
                this.lsh = JSON.parse(JSON.stringify(this.lsh))
                Object.entries(this.lsh.financeConfig).forEach(e => {
                    delete this.lsh.financeConfig[e[0]].zipcodeArr
                })

                // set img online
                this.data.imageDetail = {
                    imageData: {
                        bank_book_account: '',
                        identify_card: '',
                        vat_company: ''
                    },
                    imageListPreview: {
                        bank_book_account: [],
                        identify_card: [],
                        vat_company: []
                    },
                    checkFetch: false,
                    imageUpload: {
                        bank_book_account: {
                            imageData: {},
                            collection: {
                                customer_id: null,
                                url: null,
                                imamge_path: null,
                                type: null,
                                version: null,
                                time_created: null
                            }
                        },
                        identify_card: {
                            imageData: {},
                            collection: {
                                customer_id: null,
                                url: null,
                                imamge_path: null,
                                type: null,
                                version: null,
                                time_created: null
                            }
                        },
                        vat_company: {
                            imageData: {},
                            collection: {
                                customer_id: null,
                                url: null,
                                imamge_path: null,
                                type: null,
                                version: null,
                                time_created: null
                            }
                        }
                    }
                }
            } else {
                this.data.shopDetail = {}
                this.activeName = '0'
            }
        }
    },
    beforeDestroy () {
    },
    data () {
        return {
            activeName: '0',
            isSubmitForm: false,
            isCancel: false,
            MenuList: [
                { id: 0, name: 'ข้อมูลร้านค้า', componentName: 'ShopInfo' },
                { id: 1, name: 'ข้อมูลทางบัญชี', componentName: 'ShopBankInfo' },
                { id: 2, name: 'ข้อมูลจำกัดจำนวนออเดอร์ของขนส่ง', componentName: 'CourierLimit' },
                { id: 3, name: 'ข้อมูลคิดบริการน้ำหนัก', componentName: 'WeightRate' },
                { id: 4, name: 'ข้อมูลคิดบริการอื่น ๆ', componentName: 'ShopService' },
                { id: 5, name: 'ตั้งค่าการคิดบริการน้ำหนัก', componentName: 'FinanceConfig' },
                { id: 6, name: 'ประวัติการแก้ไข', componentName: 'LogHistory' }

            ],
            log: {
                type: 'Shop',
                user_id: null,
                shop_id: null,
                editor_email: null,
                editor_value: null,
                payload: {
                    lhs: {},
                    rhs: {}
                },
                timestamp: null
            },
            paramForm: initForm,
            lsh: initForm
        }
    },
    computed: {
        currentTabComponent: {
            get: function () {
                return this.MenuList[this.activeName].componentName
            }
        },
        checkBtnShow () {
            if (this.data.hasOwnProperty('btnSaveShow')) {
                if (this.data.btnSaveShow) {
                    return true
                } else {
                    return false
                }
            }
            return true
        }
    },
    methods: {
        checkDisable (id) {
            if (this.data.hasOwnProperty('is_customer_regis')) {
                if (this.data.is_customer_regis) {
                    if (id === 1) {
                        return true
                    }
                    return false
                }
                return false
            }
            return false
        },
        handleClose (done) {

        },
        validateInputConfirmSubmit (input) {
            if (input) {
                if (!input.trimEnd()) {
                    return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
                } else return true
            } else return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
        },
        async submitForm () {
            this.isSubmitForm = true
            let validateShopInfo = this.validateShopInfo()
            let validateShopBank = this.validateShopBankShop()
            let validateShopService = this.validateShopService()
            if (this.data.hasOwnProperty('is_customer_regis')) {
                if (this.data.is_customer_regis) {
                    validateShopBank = true
                }
            }
            // let customerZipcodeInvalid = false **
            // let pickupZipcodeInvalid = false **
            // let bankAccountInvalid = false **
            // this.$refs['shopDialogInfo'].$refs['zipcode-system-customer'] && **
            // if (this.$refs['shopDialogInfo'].$refs['zipcode-system-pickup']) {
            //     // this.$refs['shopDialogInfo'].$refs['zipcode-system-customer'].$v.$touch() **
            //     this.$refs['shopDialogInfo'].$refs['zipcode-system-pickup'].$v.$touch()
            //     // customerZipcodeInvalid = (this.$refs['shopDialogInfo'].$refs['zipcode-system-customer'] && this.$refs['shopDialogInfo'].$refs['zipcode-system-customer'].$v.$invalid) **
            //     pickupZipcodeInvalid = (this.$refs['shopDialogInfo'].$refs['zipcode-system-pickup'] && this.$refs['shopDialogInfo'].$refs['zipcode-system-pickup'].$v.$invalid)
            // } **
            // if (this.$refs['shopDialogInfo'].$refs['zipcode-system-bank']) {
            //     this.$refs['shopDialogInfo'].$refs['zipcode-system-bank'].$v.$touch()
            //     bankAccountInvalid = (this.$refs['shopDialogInfo'].$refs['zipcode-system-bank'] && this.$refs['shopDialogInfo'].$refs['zipcode-system-bank'].$v.$invalid)
            // } **
            // || customerZipcodeInvalid || pickupZipcodeInvalid || bankAccountInvalid **
            const invalidShopDetailForm = (!validateShopInfo || !validateShopBank || !validateShopService)
            if (invalidShopDetailForm) {
                this.$notify({
                    title: 'Warning',
                    message: 'กรุณาตรวจสอบข้อมูล',
                    type: 'warning'
                })
                if (!validateShopInfo) {
                    this.activeName = '0'
                    this.$nextTick(() => {
                        this.$refs.shopDialogInfo.$refs['shopInfo'].validate()
                        // this.$refs['shopDialogInfo'].$refs['zipcode-system-customer'].$v.$touch() **
                        // this.$refs['shopDialogInfo'].$refs['zipcode-system-pickup'].$v.$touch() **
                    })
                } else if (!validateShopBank) {
                    this.activeName = '1'
                    this.$nextTick(() => {
                        this.$refs.shopDialogInfo.$refs['shopBankInfo'].validate()
                        // this.$refs['shopDialogInfo'].$refs['zipcode-system-bank'].$v.$touch() **
                    })
                } else if (!validateShopService) {
                    this.activeName = '4'
                    this.$nextTick(() => {
                        this.$refs.shopDialogInfo.$refs['shopServiceInfo'].validate()
                    })
                }
            } else {
                this.$prompt('', 'สาเหตุที่ต้องแก้ไข', {
                    confirmButtonText: 'บันทึก',
                    cancelButtonText: 'ยกเลิก',
                    inputType: 'textarea',
                    inputValidator: this.validateInputConfirmSubmit
                }).then(async value => {
                    this.$loading()
                    for (const key in this.paramForm) {
                        if (key === 'dimWeightMultiplier') {
                            // this.paramForm[key] = null
                            this.paramForm[key] = this.data.shopDetail[key]
                        } else {
                            this.paramForm[key] = this.data.shopDetail[key]
                        }
                    }
                    Object.entries(this.paramForm.financeConfig).forEach(e => {
                        e[1].zipcodeArr.forEach(s => {
                            if (!this.paramForm.financeConfig[e[0]].remoteZone.hasOwnProperty(s)) {
                                this.paramForm.financeConfig[e[0]].remoteZone[s] = []
                            }
                        })
                        delete e[1].zipcodeArr
                    })
                    if (this.lsh.pickedUpAddress !== this.paramForm.pickedUpAddress ||
                    this.lsh.pickedUpDistrict !== this.paramForm.pickedUpDistrict ||
                     this.lsh.pickedUpProvince !== this.paramForm.pickedUpProvince ||
                      this.lsh.pickedUpSubDistrict !== this.paramForm.pickedUpSubDistrict ||
                       this.lsh.pickedUpZipcode !== this.paramForm.pickedUpZipcode) {
                        this.paramForm.pickupAddressId = null
                    }
                    try {
                        this.paramForm['targetUserId'] = this.data.shopDetail.userId
                        let res = await fgApi.shop.updateShop(this.paramForm)
                        const isEmpty = (obj) => {
                            for (var key in obj) {
                                if (obj.hasOwnProperty(key)) { return true }
                            }
                            return false
                        }
                        const env = (mode) => {
                            if (mode === 'production') {
                                return 'prod'
                            } else {
                                return mode
                            }
                        }
                        for (let [key, value] of Object.entries(this.data.imageDetail.imageUpload)) {
                            if (isEmpty(value.imageData)) {
                                console.log('upload image type -> ', key)
                                let storageRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).storage().ref()
                                let mountainsRef = await storageRef.child(value.collection.imamge_path)
                                let putImage = await mountainsRef.put(value.imageData.raw)
                                let urlImg = await putImage.ref.getDownloadURL()
                                let collectRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).firestore()
                                collectRef.collection(value.collection.path).add({
                                    customer_id: this.data.shopDetail.userId,
                                    url: urlImg,
                                    imamge_path: value.collection.imamge_path,
                                    type: value.collection.type,
                                    version: value.collection.version,
                                    time_created: Date()
                                })
                            }
                        }
                        if (res.success) {
                            this.$message({
                                message: 'บันทึกข้อมูลเรียบร้อย.',
                                type: 'success'
                            })
                            this.log.payload.lhs = this.lsh
                            this.log.payload.rhs = this.paramForm
                            this.log.editor_email = this.$store.get('user/objUser').email
                            this.log.editor_value = value.value
                            this.log.shop_id = this.paramForm.shopId
                            this.log.timestamp = this.$dayjs().unix()
                            this.log.facebook_page_id = this.paramForm.facebookPageId
                            this.log.auto_send_message = this.paramForm.autoSendMessage
                            fgApi.log.setLogFinance(this.log)
                            this.data.dialogVisible = false
                            this.$emit('close')
                        } else {
                            this.$notify.error({
                                title: 'Error',
                                message: res.message
                            })
                        }
                    } catch (error) {
                        this.$notify.error({
                            title: 'Error',
                            message: error
                        })
                    }
                    this.$loading().close()
                }).catch(() => {
                    console.error('canceled')
                })
            }
        },
        onCancel () {
            this.data.dialogVisible = false
            this.isSubmitForm = false
            this.isCancel = true
        },
        validateShopInfo () {
            let keyValidate = ['name', 'shopCode', 'phoneNumber', 'address', 'province', 'district', 'subDistrict', 'zipcode', 'pickedUpDistrict', 'pickedUpProvince', 'pickedUpSubDistrict', 'pickedUpZipcode', 'pickedUpAddress']
            let valuedateCheck = true

            for (let e of keyValidate) {
                if (!this.data.shopDetail[e]) {
                    valuedateCheck = false
                    break
                }
            }
            return valuedateCheck
        },
        validateShopBankShop () {
            let keyValidate = ['bankAccountName', 'taxId', 'bankAccountEmail', 'bankAccountAddress', 'bankAccountSubDistrict', 'bankAccountDistrict', 'bankAccountProvince', 'bankAccountZipcode', 'bankAccountNumber', 'bankName']
            let keyValidateLegaName = ['legalName', 'bankAccountName', 'taxId', 'bankAccountEmail', 'bankAccountAddress', 'bankAccountSubDistrict', 'bankAccountDistrict', 'bankAccountProvince', 'bankAccountZipcode', 'bankAccountNumber', 'bankName']
            let valuedateCheck = true
            let keyValue = this.data.shopDetail.bankAccountType === 1 ? keyValidateLegaName : keyValidate
            // if (this.data.shopDetail.bankAccountType === 1) {
            //     keyValue = keyValidateLegaName
            // } else {
            //     keyValue = keyValidate
            // }
            for (let e of keyValue) {
                if (e === 'bankAccountEmail') {
                    if (!/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.data.shopDetail[e])) {
                        valuedateCheck = false
                        break
                    }
                } else if (!this.data.shopDetail[e]) {
                    valuedateCheck = false
                    break
                }
            }
            return valuedateCheck
        },
        validateShopService () {
            let keyValidate = []
            let valuedateCheck = true
            for (let e of keyValidate) {
                if (!this.data.shopDetail[e]) {
                    valuedateCheck = false
                    break
                }
            }
            return valuedateCheck
        }
    }
}
</script>

<style lang="scss">
.modalEditShop {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
    .el-dialog__footer {
        border-top:1px solid #dcdfe6;
    }
}
</style>
